import type { SVGProps } from "react";
export interface BaseballIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function BaseballIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: BaseballIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M17.787 9.795a1.126 1.126 0 0 1 1.29.78l.027.112.022.116a18 18 0 0 1 2.798-.368 1.125 1.125 0 0 1 .133 2.246 15.6 15.6 0 0 0-2.506.33l.054.276a1.126 1.126 0 0 1-2.197.478 8 8 0 0 0-1.261.79l.15.15a1.126 1.126 0 0 1-1.593 1.59l-.166-.165a8 8 0 0 0-.836 1.262l.01.003.113.027a1.126 1.126 0 0 1-.423 2.2l-.115-.017-.351-.069c-.165.773-.245 1.595-.281 2.498l-.01.115a1.125 1.125 0 0 1-2.237-.205l.024-.515c.047-.78.135-1.553.295-2.318l-.04-.007-.111-.026a1.126 1.126 0 0 1 .422-2.2l.114.017.305.059c.37-.83.866-1.635 1.526-2.42l-.239-.24-.077-.084a1.126 1.126 0 0 1 1.583-1.582l.085.076.25.25a10.4 10.4 0 0 1 2.422-1.464l-.072-.378-.016-.113a1.125 1.125 0 0 1 .908-1.204M12.514.887c.62.025 1.104.548 1.08 1.17-.039.953-.128 1.897-.323 2.83l.041.008.112.028a1.124 1.124 0 0 1-.422 2.197l-.115-.016-.306-.059c-.37.83-.866 1.633-1.526 2.419l.24.24.078.087a1.124 1.124 0 0 1-1.584 1.582l-.085-.078-.252-.25a10.4 10.4 0 0 1-2.42 1.463l.072.38.016.114a1.124 1.124 0 0 1-2.197.423l-.028-.113-.023-.116a18 18 0 0 1-2.795.368l-.116.001a1.125 1.125 0 0 1-.019-2.247l.914-.073q.824-.086 1.593-.26l-.053-.273-.016-.114a1.123 1.123 0 0 1 2.21-.365q.648-.326 1.261-.791l-.146-.147-.078-.085a1.125 1.125 0 0 1 1.584-1.583l.085.078.164.164c.337-.42.61-.84.836-1.263l-.009-.002-.11-.027a1.124 1.124 0 0 1 .421-2.198l.114.017.35.067c.165-.773.247-1.595.283-2.498A1.124 1.124 0 0 1 12.514.887"
      />
      <path
        fill={color}
        d="M20.875 12a8.875 8.875 0 1 0-17.75 0 8.875 8.875 0 0 0 17.75 0m2.25 0c0 6.144-4.98 11.124-11.124 11.125S.875 18.145.875 12 5.856.875 12.001.875c6.143 0 11.124 4.981 11.124 11.126Z"
      />
    </svg>
  );
}
